import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/themeFour/provider.png'


const _hoisted_1 = { class: "panel_container" }
const _hoisted_2 = ["src"]


export default /*@__PURE__*/_defineComponent({
  __name: 'providerCard',
  props: {
    itemData: {}
  },
  setup(__props: any) {

const props = __props


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_row, {
      class: "titleHead",
      justify: "space-between"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "2",
          style: {"display":"flex","align-items":"center"}
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "",
              width: "100%"
            }, null, -1)
          ])),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "22",
          class: "titleText"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('home.provider')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("img", {
      src: _ctx.itemData.url,
      alt: "",
      width: "90%",
      style: {"padding":"0 5%","background":"rgb(2, 74, 73)"}
    }, null, 8, _hoisted_2)
  ]))
}
}

})